export default function RecommendationReportController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  confirmDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Recommendation Report Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleUnattachRecommendationReport = _handleUnattachRecommendationReport;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleUnattachRecommendationReport($event) {
    ssDialogService.dialogs.auditTrail.deleteRecommendationReportConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Attached Report?',
        message: `Are you sure you want to remove Report "${vm.recommendationReport.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteRecommendationReportConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.detachRecommendationReport(vm.recommendationReport.recommendationReportInstanceId)
      .then(() => {
        alerts.success('The report has been removed successfully.');
        $rootScope.$broadcast('refreshAMRecommendationReports', { recommendationId: vm.recommendationReport.recommendationId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while removing the report.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteRecommendationReportConfirmDialog);
  }
}

RecommendationReportController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'confirmDialog',
  'loaderService',
  'ssDialogService'
];
